export const SEASONS = [
    {
        key: 'pw_26_27',
        label: '26/27 Regular Season',
        divisionName: 'Peewee Major',
        chipLabel: '26/27 Peewee Major',
        seasonId: '15220',
        divisionId: '81567',
        totalTeams: 15,
        startSchedule: 'Sep 18, 2026',
        endSchedule: 'Jan 30, 2027',
        teamName: 'Jets',
        teamId: '528217',
        isCurrent: true,
    },
    {
        key: 'pw_25_26',
        label: '25/26 Regular Season',
        divisionName: 'Peewee Minor',
        chipLabel: '25/26 Peewee Minor',
        seasonId: '10449',
        divisionId: '57718',
        totalTeams: 13,
        startSchedule: 'Sep 13, 2025',
        endSchedule: 'Feb 1, 2026',
        teamName: 'Jets',
        teamId: '372150',
        isCurrent: false,
    },
    {
        key: 'sq_24_25',
        label: '24/25 Regular Season',
        divisionName: 'Squirt Major',
        chipLabel: '24/25 Squirt Major',
        seasonId: '6606',
        divisionId: '37597',
        totalTeams: 16,
        startSchedule: 'Sep 13, 2024',
        endSchedule: 'Feb 2, 2025',
        teamName: 'Jets',
        teamId: '',
        isCurrent: false,
    },
    {
        key: 'sq_23_24',
        label: '23/24 Regular Season',
        divisionName: 'Squirt Minor',
        chipLabel: '23/24 Squirt Minor',
        seasonId: '3579',
        divisionId: '20664',
        totalTeams: 17,
        startSchedule: 'Sep 9, 2023',
        endSchedule: 'Feb 4, 2024',
        teamName: 'Jets',
        teamId: '',
        isCurrent: false,
    },
];

export const CURRENT_SEASON = SEASONS[0]; // pw_26_27
export const CURRENT_SEASON_KEY = CURRENT_SEASON.key;

export function getSeason(key) {
    if (!key) return CURRENT_SEASON;
    return SEASONS.find(s => s.key === key) || null;
}

export function getPreviousSeason(key) {
    const chronologicalOrder = ['sq_23_24', 'sq_24_25', 'pw_25_26', 'pw_26_27'];
    const idx = chronologicalOrder.indexOf(key);
    if (idx > 0) {
        return getSeason(chronologicalOrder[idx - 1]);
    }
    return null;
}